<template>
    <div class="filters">
        <v-layout row>
            <v-flex md4 v-if="hasAllRoles(['OrganizationView']) && !activeImpersonate">
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Organization</span>
                        </div>
                        <organization-autocomplete
                            v-model="filters.organization"
                        ></organization-autocomplete>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md4 v-if="hasAllRoles(['FleetView'])">
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Fleet name</span>
                        </div>
                        <fleet-autocomplete
                            v-model="filters.fleet"
                            :organization="filters.organization"
                        ></fleet-autocomplete>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md4 v-if="hasAllRoles(['UserView'])">
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Users</span>
                        </div>
                        <user-autocomplete
                            v-model="filters.users"
                            :multiple="true"
                            :organizations="filters.organization"
                            :fleets="filters.fleet"
                        ></user-autocomplete>
                    </v-layout>
                </div>
            </v-flex>

        </v-layout>
    </div>
</template>

<script>

import OrganizationAutocomplete from '@/views/Organizations/components/OrganizationAutocomplete'
import FleetAutocomplete from '@/views/Fleets/components/FleetAutocomplete'
import UserAutocomplete from '@/views/Users/components/UserAutocomplete'
import {mapGetters} from "vuex";

export default {
    name: 'FleetsFilters',
    components: {
        OrganizationAutocomplete,
        FleetAutocomplete,
        UserAutocomplete
    },
    props: {
        filters: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters('authModule', [
            'getActiveOrganization',
            'getDefaultOrganization'
        ]),
        activeImpersonate () {
            return this.getActiveOrganization !== this.getDefaultOrganization
        }
    },
    watch: {
        'filters.organization': function (newVal, oldVal) {
            this.filters.fleet = null
            this.filters.users = null
        },
        'filters.fleet': function (newVal, oldVal) {
            this.filters.users = null
        },
        deep: true
    }
}
</script>

<style lang="scss" scoped>
.filters {
    .checkbox {
        margin-left: 5px !important;

        ::v-deep .v-input__slot {
            min-height: 0 !important;
            margin-top:12px;
        }
    }
}
</style>
